import palette from '@lib/core/src/theme/palette';
import { alpha, Stack, styled, Typography } from '@mui/material';

export const CategoryTitle = styled(Typography)({
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '14px',
  color: palette.grey[500],
  alignSelf: 'flex-start'
});

export const RequiredText = styled(Typography)({
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '14px',
  color: palette.grey[1800],
  alignSelf: 'flex-start'
});

export const ComingSoon = styled(Typography)({
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '16px',
  color: palette.grey[500]
});

export const Content = styled(Stack)({
  alignItems: 'center',
  gap: '15px',
  overflowY: 'auto'
});

export const IntegrationsCategory = styled(Stack)({
  gap: '9px',
  width: '100%',
  padding: '0 30px'
});

export const IntegrationsRow = styled(Stack)({
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '12px'
});

export const IntegrationContainer = styled(Stack)(
  ({ disabled }: { disabled?: boolean | undefined }) => ({
    padding: '16px',
    cursor: disabled ? 'default' : 'pointer',
    height: '120px',
    alignItems: 'flex-start',
    opacity: disabled ? 0.5 : 1,
    border: `1px solid ${palette.stroke.idle}`,
    gap: '8px',
    width: '300px',
    borderRadius: '16px'
  })
);

export const IntegrationLogos = styled(Stack)({
  flexDirection: 'row',
  gap: '8px',
  alignSelf: 'start'
});

export const LogoContainer = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  padding: '8px',
  borderRadius: '8px',
  border: `1px solid ${palette.stroke.subtle}`
});

export const IntegrationFooter = styled(Stack)({
  width: '100%',
  gap: '8px',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
});

export const IntegrationSmallLogos = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'start',
  gap: '4px'
});

export const ConnectButton = styled(Stack)(({ disabled }: { disabled?: boolean | undefined }) => ({
  padding: '8px 12px',
  cursor: disabled ? 'default' : 'pointer',
  justifyContent: 'center',
  opacity: disabled ? 0.5 : 1,
  ':hover': { opacity: disabled ? 0.5 : 0.8 },
  alignItems: 'center',
  gap: '4px',
  width: '100px',
  border: `1px solid ${palette.grey[200]}`,
  backgroundColor: disabled ? alpha(palette.grey[200], 0.5) : palette.grey[800],
  borderRadius: '32px'
}));

export const ConnectButtonText = styled(Typography)({
  fontSize: '13px',
  fontWeight: 'bold',
  color: palette.black
});

export const ProviderTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '16px'
});
